import React, { useEffect } from 'react';
import Loader from '../../utils/Loader';
import { useStateMachine } from 'little-state-machine';
import updateAction from './updateAction';
import { connect } from 'react-redux';
import { addOnboardDetails } from '../../redux/profile/profile.actions';
import { withRouter } from 'react-router-dom';
import { compose } from 'redux';
import Card from 'react-bootstrap/Card';

const Final = ({ addOnboardDetails, history }) => {
	Loader.hide();

	const { state } = useStateMachine(updateAction);
	useEffect(() => {
		addOnboardDetails(state?.data);
	}, [addOnboardDetails, state.data]);

	return (
		<Card>
			<Card.Header className="setup-content" id="final">
				<h3>You're done!</h3>
			</Card.Header>
			<Card.Body>
				<h4>Thank you!</h4>

				<button
					aria-label="dashboard"
					className="btn btn-success pull-right"
					onClick={() => {
						history.push('/mydashboard');
					}}
					type="button"
				>
					Go to Dashboard
				</button>
			</Card.Body>
		</Card>
	);
};

const mapDispatchToProps = (dispatch) => {
	return {
		addOnboardDetails: (obj) => dispatch(addOnboardDetails(obj)),
	};
};

export default compose(withRouter, connect(null, mapDispatchToProps))(Final);
